import type { OptionsVisibility } from '@atlassian/ui-modifications-core/types';
import { FieldValueLookupError } from '@atlassian/ui-modifications-core/utils';
import type {
	PriorityPublicGetValue,
	PriorityPublicSetValue,
} from '@atlassian/jira-ui-modifications-common/src/common/utils/common/fields/priority.tsx';
import { applyOptionsVisibilityRule } from '@atlassian/jira-ui-modifications-common/src/common/utils/common/utils/apply-options-visibility-rule/index.tsx';
import { getAvailableOptionsVisibilityRule } from '@atlassian/jira-ui-modifications-common/src/common/utils/common/utils/get-available-options-visibility-rule/index.tsx';
import { singleValueLookup } from '@atlassian/jira-ui-modifications-common/src/common/utils/common/utils/single-value-lookup/index.tsx';

export type PriorityInternalValue = {
	label: string;
	value: string;
	iconUrl?: string;
};

export const transformPrioritySetOptionsVisibility = (
	optionsVisibility: OptionsVisibility,
	lookupValues: PriorityPublicGetValue[],
): PriorityPublicGetValue[] => applyOptionsVisibilityRule(optionsVisibility, lookupValues, 'id');

export const transformPriorityGetOptionsVisibility = (
	optionsVisibility: OptionsVisibility,
	lookupValues: PriorityPublicGetValue[],
): OptionsVisibility => getAvailableOptionsVisibilityRule(optionsVisibility, lookupValues, 'id');

export const prioritySetValueTransformer = (
	value: PriorityPublicSetValue,
	lookupValues?: PriorityPublicGetValue[],
): PriorityInternalValue => {
	const lookupValue = singleValueLookup<PriorityPublicGetValue>(value, lookupValues, 'id');

	if (!lookupValue) {
		throw new FieldValueLookupError();
	}

	return {
		label: lookupValue.name,
		value: lookupValue.id,
		iconUrl: lookupValue.iconUrl,
	};
};

export const transformPriorityGetValue = (
	priority: PriorityInternalValue | undefined,
): PriorityPublicGetValue | null => {
	if (!priority) {
		return null;
	}

	const { label, value, iconUrl } = priority;

	return { name: label, id: value, iconUrl };
};
